// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html, body {\n    margin: 0;\n    padding: 0;\n}\nhtml, body, #root { min-height: 100vh; background-color: #e8f3ff; }", "",{"version":3,"sources":["webpack://src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;AACA,oBAAoB,iBAAiB,EAAE,yBAAyB,EAAE","sourcesContent":["html, body {\n    margin: 0;\n    padding: 0;\n}\nhtml, body, #root { min-height: 100vh; background-color: #e8f3ff; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
